import { graphql, useLazyLoadQuery } from "react-relay";

import { SettingsTabsLayout } from "../SettingsTabsLayout";
import { McpSettings } from "./McpSettings";
import { McpSettingsPage } from "./McpSettingsPage";

import type { McpSettingsRootQuery } from "./__generated__/McpSettingsRootQuery.graphql";

export function McpSettingsRoot() {
  const data = useLazyLoadQuery<McpSettingsRootQuery>(
    graphql`
      query McpSettingsRootQuery {
        ...McpSettings_query
        ...McpSettingsPage_query
      }
    `,
    {},
  );

  return (
    <McpSettingsPage queryRef={data}>
      <SettingsTabsLayout>
        <McpSettings queryRef={data} />
      </SettingsTabsLayout>
    </McpSettingsPage>
  );
}
